import store from '../store'

const hasPermission = (element) => {
  var permissionArr = store.getters.permission
  return permissionArr.some(temp => element.indexOf(temp) >= 0)
}
const hasPageAuth = (element) => {
  var disablePage = store.getters.disablePage
  return disablePage.some(temp => element.indexOf(temp) >= 0)
}

export default {
  install (Vue) {
    Object.defineProperties(Vue.prototype, {
      $auth: {
        value: {
          hasPageAuth,
          hasPermission
        }
      }
    })
  }
}
